module.exports = __webpack_public_path__ + "img/part-3-title.45415265.png";